<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Update Client Field</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Client:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <ClientAutocomplete
                :key="companySearchComponentKey"
                class="searchbox"
                :list="searchCompany"
                :searchOn="'company_or_registration_no'"
                @event-name="selectClient"
              ></ClientAutocomplete>
              {{clientFieldDescription.company_name}}
            </div>
            <span class="text-danger text-sm mt-2">{{
              please_choose_client
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full" v-if="user_role=='Global Administrator'">
              <vs-input
                class="w-full"
                name="name"
                v-model="clientFieldDescription.name"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
               <div class="vx-col sm:w-1/3 w-full" v-else>
              <vs-input disabled
                class="w-full"
                name="name"
                v-model="clientFieldDescription.name"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('name')"
              >{{ errors.first("name") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="description"
                v-model="clientFieldDescription.description"
                v-validate="'required'"
                data-vv-as="Fields Description"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>
                    <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Level:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-radio
                v-model="clientFieldDescription.level"
                :vs-value="'account'"
                class="mr-4"
                vs-name="level"
                >Account</vs-radio
              >
              <vs-radio
                v-model="clientFieldDescription.level"
                :vs-value="'contact'"
                class="mr-4"
                vs-name="contact"
                >Contact</vs-radio
              >
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('sales_developer_access')"
              >{{ errors.first("sales_developer_access") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Sales Developer Access:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-radio
                v-model="clientFieldDescription.sales_developer_access"
                :vs-value="'yes'"
                class="mr-4"
                vs-name="sales_developer_access"
                >Yes</vs-radio
              >
              <vs-radio
                v-model="clientFieldDescription.sales_developer_access"
                :vs-value="'no'"
                class="mr-4"
                vs-name="sales_developer_access"
                >No</vs-radio
              >
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('sales_developer_access')"
              >{{ errors.first("sales_developer_access") }}</span
            >
          </div>
                    <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Is Historic Notes:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
             <vs-checkbox
                v-model="clientFieldDescription.is_historic_notes"
                :vs-value="'yes'"
                class="mr-4"
                vs-name="is_historic_notes"
              >Yes</vs-checkbox>
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('is_historic_notes')"
              >{{ errors.first("is_historic_notes") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Type:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                label="name"
                name="type"
                :options="types"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="clientFieldDescription.type"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('type')"
              >{{ errors.first("type") }}</span
            >
            <span class="text-danger text-sm mt-2">{{
              please_choose_options
            }}</span>
          </div>
          <div
            class="vx-row mb-6"
            v-if="
              clientFieldDescription.type == 'dropdown' ||
                clientFieldDescription.type.value == 'dropdown' ||
                clientFieldDescription.type == 'checkbox' ||
                clientFieldDescription.type.value == 'checkbox' ||
                clientFieldDescription.type == 'choose_one' ||
                clientFieldDescription.type.value == 'choose_one'
            "
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span>Choose Existing List:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-checkbox v-model="chooseExistingList"></vs-checkbox>
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('type')"
              >{{ errors.first("type") }}</span
            >
          </div>

          <div
            class="vx-row mb-6"
            v-if="
              clientFieldDescription.type == 'dropdown' ||
                clientFieldDescription.type.value == 'dropdown' ||
                clientFieldDescription.type == 'checkbox' ||
                clientFieldDescription.type.value == 'checkbox' ||
                clientFieldDescription.type == 'choose_one' ||
                clientFieldDescription.type.value == 'choose_one'
            "
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span>Value:</span>
            </div>

            <div class="vx-col sm:w-1/5 w-full">
              <vs-input
                class="w-full"
                name="email"
                v-model="clientFieldDescription.value"
                data-vv-as="Value"
              />
            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <vs-button @click="addValue" color="primary" type="filled"
                >Add</vs-button
              >
            </div>
          </div>
          <div class="vx-row mb-6" v-if="chooseExistingList">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Existing List:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-row vs-w="12" class="mb-5">
                <vs-col vs-lg="8" vs-sm="8" vs-xs="12"
                  >
                     <FieldsAutocomplete
                    :key="companySearchComponentKey"
                    class="searchbox"
                    :list="searchExistingFieldLists"
                    :searchOn="'client-field'"
                    @event-name="handleChildEvent"
                  ></FieldsAutocomplete>
                  
                  <!-- <v-select
                    class="mb-4"
                    label="name"
                    name="existing_list"
                    :options="existing_fields_list"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="fields.existing_list"
                  /> -->
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="4"
                  vs-sm="4"
                  vs-xs="12"
                >
                </vs-col>
              </vs-row>

              <div class="vx-col sm:w-1/2 w-full">
                <span v-for="elv in existing_list_values" class="p-2">
                  <vs-input
                    class="w-full"
                    name="existing_list_value"
                    v-model="elv.value"
                  />
                  <vs-icon
                    class="removeButtonClass"
                    @click="removeExistingListValues(elv)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </span>
              </div>
            </div>
          </div>

          <div
            class="vx-row mb-6"
            v-if="
              clientFieldDescription.type == 'dropdown' ||
                clientFieldDescription.type.value == 'dropdown' ||
                clientFieldDescription.type == 'checkbox' ||
                clientFieldDescription.type.value == 'checkbox' ||
                clientFieldDescription.type == 'choose_one' ||
                clientFieldDescription.type.value == 'choose_one'
            "
          >
            <template>
              <div class="vx-col sm:w-1/5 w-full"></div>
            </template>

            <div
              class="vx-col sm:w-1/4 w-full"
              v-if="clientFieldDescription.values"
            >
              <template v-for="(v, index) in clientFieldDescription.values">
                <span :key="index" class="p-2">
                  <vs-input
                    class="w-full"
                    name="field_new_values"
                    v-model="v.value"
                  />
                  <vs-icon
                    class="removeButtonClass"
                    @click="removeSelectedValue(v)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </span>
              </template>
            </div>
          </div>

          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="updateForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <DataGrid :context="'clientFields'" 
            ref="clientFields"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import moduleClientsManagement from "@/store/clients-management/moduleClientsManagement.js";
import FieldsAutocomplete from "@/components/autocomplete/FieldsAutocomplete.vue";
import moduleClientFieldsManagement from "@/store/fields-management/client-fields-management/moduleClientFieldsManagement.js";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
            selected_client: null,

      companySearchComponentKey: 0,
      please_choose_client:null,
      please_choose_options: null,
      clientFieldDescription: [],
      fieldId: null,
      chooseExistingList: false,
      columnDefs: [
        {
        headerName: "Client",
        field: "company_name",
        width: 400,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
      },
        {
          headerName: "Name",
          field: "name",
          width: 400,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Description",
          field: "description",
          width: 400,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
         {
        headerName: "Level",
        field: "level",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
        {
          headerName: "Type",
          field: "type",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Value",
          field: "values",
          width: 550,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Sales Developer Access",
          field: "sales_developer_access",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Is Historic Notes",
          field: "is_historic_notes",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        }
      ],
      user_role:null,
      dataSource: {},
      records: [],
      selected: [],
      allFields: [],
      abilities: null,
      existing_list_values: null,
      existing_fields_list: [],
      fields: {
        values: [],
        name: null,
        description: null,
        type: null,
        level:'account',
        value: null,
        sales_developer_access: "yes",
        existing_list: null
      },
      types: [
        {
          name: "Text",
          value: "text"
        },
        {
          name: "Number",
          value: "number"
        },
        {
          name: "Textarea",
          value: "textarea"
        },
        {
          name: "Date",
          value: "date"
        },
        {
          name: "DateTime",
          value: "datetime"
        },
        {
          name: "Checkbox",
          value: "checkbox"
        },
        {
          name: "Dropdown",
          value: "dropdown"
        },
        {
          name: "Choose One",
          value: "choose_one"
        }
      ]
    };
  },
  components: {
    "v-select": vSelect,
    moduleClientFieldsManagement,
    DataGrid,
    FieldsAutocomplete,
    ClientAutocomplete
  },
 created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_role = userInfo["userRole"];
    if (!moduleClientFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "ClientFieldsManagement",
        moduleClientFieldsManagement
      );
      moduleClientFieldsManagement.isRegistered = true;
    }

        if (!moduleMasterFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "MasterFieldsManagement",
        moduleMasterFieldsManagement
      );
      moduleMasterFieldsManagement.isRegistered = true;
    }


    if (!moduleClientsManagement.isRegistered) {
      self.$store.registerModule("clientsManagement", moduleClientsManagement);
      moduleClientsManagement.isRegistered = true;
    }
  },
  mounted() {
    this.fieldId = this.$route.params.fieldId;
    this.fetchClientField();
    this.getExistingFieldLists();
  },
  watch: {
    "clientFieldDescription.type.value": function(val) {
      if (val) {
        this.please_choose_options = null;
      }
    },
    // "fields.existing_list": function(val) {
    //   if (val) {
    //     let filtered_value = this.existing_fields_list.filter(ele => {
    //       return ele.field_id == val.field_id;
    //     });
    //     if (filtered_value) {
    //       let lists = filtered_value[0];
    //       this.existing_list_values = JSON.parse(lists.values);
    //     }

    //     console.log(this.existing_list_values);
    //   }
    // },
    chooseExistingList: function(val) {
      if (val) {
        this.chooseExistingList = true;
        // this.existing_list_values = null
        // // let filtered_value = this.existing_fields_list.filter(ele => {
        // //   return ele.field_id == val.field_id;
        // // });
        // let filtered_value = this.existing_fields_list
        // if (filtered_value) {
        //   let lists = filtered_value[0];
        //   this.existing_list_values = JSON.parse(lists.values);
        // }

        // console.log(this.existing_list_values);
      } else {
        this.existing_list_values = [];
      }
    },
    "clientFieldDescription.type": function(val) {
      // if(this.clientFieldDescription.type == val){
      //   this.clientFieldDescription.type.value == val
      // }
      // alert(val)
    }
  },
  methods: {
     selectClient() {
                   this.clientFieldDescription.company_name = null;

      let clients = moduleClientsManagement.state.clients.datas;
      if (clients) {
        this.selected_client = clients[0];
      }
    },
    searchCompany(inputValue) {
      this.please_choose_client = null;

      return this.$store
        .dispatch("clientsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data = moduleClientsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
     searchExistingFieldLists(inputValue) {
      let search_from = "client_field";
      return this.$store
        .dispatch("MasterFieldsManagement/searchExistingFieldLists", {
          search_from: search_from,
          inputValue: inputValue
        })
        .then(response => {
          if (response) {
            let data = response.data;
            if (data) {
              data = JSON.parse(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].field_id,
                  name: data[property].name
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    handleChildEvent() {
      let selected_field = moduleClientFieldsManagement.state.selected_fields;

        console.log("EXis" , this.existing_fields_list)


      if (selected_field) {
        let filtered_value = this.existing_fields_list.filter(ele => {
          return ele.field_id == selected_field.id;
        });
 

        console.log("Filtered" , filtered_value)



        if (filtered_value) {
          let lists = filtered_value[0];
          this.existing_list_values = JSON.parse(lists.values);
        }

        console.log(this.existing_list_values);
      }
    },
    removeSelectedValue(value) {
      this.clientFieldDescription.values = this.clientFieldDescription.values.filter(
        item => {
          return item != value;
        }
      );
    },
    removeExistingListValues(value) {
      this.existing_list_values = this.existing_list_values.filter(item => {
        return item != value;
      });
    },
    addValue() {
      if (this.clientFieldDescription.values == null) {
        this.clientFieldDescription.values = [];
      }

      if (
        this.clientFieldDescription.value &&
        !this.clientFieldDescription.values.includes(
          this.clientFieldDescription.value
        )
      )
        this.clientFieldDescription.values.push({
          value: this.clientFieldDescription.value
        });
      this.clientFieldDescription.value = null;
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch(
              "ClientFieldsManagement/getAllClientFields",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.clientFields.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.clientFields.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    },
    updateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateFields();
        }
      });
    },
    updateFields() {
      if (this.clientFieldDescription.values == null) {
        this.clientFieldDescription.values = [];
      }

      if (this.existing_list_values == null) {
        this.existing_list_values = [];
      }
      

      if (
        this.clientFieldDescription.type.value == "checkbox" ||
        this.clientFieldDescription.type == "checkbox" ||
        this.clientFieldDescription.type.value == "dropdown" ||
        this.clientFieldDescription.type == "dropdown" ||
        this.clientFieldDescription.type.value == "choose_one" ||
        this.clientFieldDescription.type == "choose_one"
      ) {
        if (
          this.clientFieldDescription.values.length == 0 &&
          this.existing_list_values.length == 0
        ) {
          this.please_choose_options =
            "Atleast one options is required for " +
            this.clientFieldDescription.type.value +
            " list.";
          return false;
        }
      }


          if (
        typeof this.selected_client !== "undefined" &&
        this.selected_client !== null
      ) {        this.clientFieldDescription.selected_client_id = this.selected_client.id;
      } else {
              if(this.clientFieldDescription.selected_client_id == null){

        this.please_choose_client = "The client field is required.";
        return false;
      }

      }

    
 


      let joined_values = [];
      joined_values = this.clientFieldDescription.values.concat(
        this.existing_list_values
      );
      joined_values = joined_values.filter(function(ele) {
        return ele != null;
      });
      this.clientFieldDescription.values = joined_values;

      if (typeof this.clientFieldDescription.type === "object") {
        this.clientFieldDescription.type = this.clientFieldDescription.type.value;
      }

      if (
        this.clientFieldDescription.type == "text" ||
        this.clientFieldDescription.type == "number" ||
        this.clientFieldDescription.type == "textarea" ||
        this.clientFieldDescription.type == "date"
      ) {
        this.clientFieldDescription.values = null;
      }

      if (this.clientFieldDescription.is_historic_notes){
        this.clientFieldDescription.is_historic_notes = 'yes';
      }


      this.$store
        .dispatch(
          "ClientFieldsManagement/updateFields",
          this.clientFieldDescription
        )
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Client Fields Exists",
              text: res.data.message
            });
                        var uniq = {}
            this.campaignFieldDescription.values = this.campaignFieldDescription.values.filter(obj => !uniq[obj.value] && (uniq[obj.value] = true));
            console.log(this.fields.values)
          } else {
            this.$vs.notify({
              color: "success",
              title: "Field Updated",
              text: "The client fields was updated successfully"
            });
            this.$router.push({ path: "/fields/client-fields" });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchClientField() {
      this.$store
        .dispatch("ClientFieldsManagement/fetchFields", this.fieldId)
        .then(res => {
          let result = JSON.parse(res.data);
          this.clientFieldDescription = result[0];
          if (this.clientFieldDescription.sales_developer_access) {
            this.clientFieldDescription.sales_developer_access = "yes";
          } else {
            this.clientFieldDescription.sales_developer_access = "no";
          }

          if(this.clientFieldDescription.client_id){
            this.clientFieldDescription.selected_client_id = this.clientFieldDescription.client_id
          }

          this.clientFieldDescription.values = JSON.parse(
            this.clientFieldDescription.values
          );
        })
        .catch(err => {
          console.error(err);
        });
    },
    getExistingFieldLists() {
      this.$store
        .dispatch(
          "ClientFieldsManagement/getExistingFieldLists",
          "client_field"
        )
        .then(res => {
          console.log("LISTS", JSON.parse(res.data));
          let result = JSON.parse(res.data);
          if (result) {
            this.existing_fields_list = result;
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
